import { RoleType } from '../types/UserTypes'

export const portalNavItems = [
  {
    type: 'ADMIN',
    display: 'Administrators',
    roles: [RoleType.SUPER_ADMIN],
  },
  {
    type: 'AUDIT',
    display: 'Audit Logs',
    roles: [RoleType.SUPER_ADMIN],
  },
  {
    type: 'SSO',
    display: 'SSO',
    roles: [RoleType.SUPER_ADMIN, RoleType.PLATFORM_MGMT],
  },
  {
    type: 'WEBHOOKS',
    display: 'Webhooks',
    roles: [RoleType.SUPER_ADMIN, RoleType.PLATFORM_MGMT],
  },
  {
    type: 'API',
    display: 'API',
    roles: [RoleType.SUPER_ADMIN, RoleType.PLATFORM_MGMT],
  },
  {
    type: 'DEMO_DATA',
    display: 'Demo Data',
    roles: [RoleType.SUPER_ADMIN, RoleType.PLATFORM_MGMT],
  },
]

export const fleetNavItems = [
  {
    type: 'MDM',
    display: 'MDM',
    roles: [RoleType.SUPER_ADMIN, RoleType.PLATFORM_MGMT],
  },
  {
    type: 'NOTIFICATION',
    display: 'Notifications',
    roles: [RoleType.SUPER_ADMIN, RoleType.PLATFORM_MGMT],
  },
  {
    type: 'CUSTOM_DNS',
    display: 'Secure DNS',
    roles: [RoleType.SUPER_ADMIN, RoleType.PLATFORM_MGMT],
    additionalRequirements: ['customDnsSettingsEnabled'],
  },
]

export type NavItems = {
  type: string
  display: string
}
